import { ModuleTree } from "vuex";
import { RootState } from "@/store/types";
import loggedInUser from "./loggedInUser";
import tags from "./tags";
import stats from "./stats";
import settings from "./settings";
import paymentSystems from "./paymentSystems";

export const modules: ModuleTree<RootState> = {
  loggedInUser,
  tags,
  stats,
  settings,
  paymentSystems,
};
